import React from 'react';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import { images } from '../../config/image';
import PublicFooter from '../../components/Layout/PublicFooter';
import strings from '../../components/Language';
import api from '../../config/api';
import axios from 'axios';
import { Button, Spin } from 'antd';

class LocationScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: strings.getLanguage(),
            access_token: null,
            isLoading: false,
            refreshing: false,
            errorMessage: [],
            hasMore: false,
            data: [],
            next_page_url: null,
            prev_page_url: null,
        }
    }

    async componentDidMount() {
        let self = this;
        const token = await localStorage.getItem('user_token');
        if (token) {
            self.setState({ access_token: token });
        }
        setTimeout(() => {
            self.loadData(api.Outlets);
        });
    }

    loadData(APIURL) {
        const self = this;
        self.setState({ refreshing: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ refreshing: false });
            self.setState({
                data: (ress.data.message && ress.data.message.data) ? ress.data.message.data : [],
                next_page_url: (ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                hasMore: (ress.data.message && ress.data.message.next_page_url) ? true : false,
                prev_page_url: (ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : ''
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ refreshing: false });
            self.setState({ ProgressBar: false });
        });
    }

    loadDataNextPage(APIURL) {
        const self = this;
        self.setState({ refreshing: true });
        axios({
            method: 'GET',
            url: APIURL,
            headers: {
                'Authorization': 'Bearer ' + self.state.access_token,
                'Content-Type': 'application/json'
            }
        }).then(function (ress) {
            self.setState({ refreshing: false });
            self.setState({
                data: (ress.data.message && ress.data.message.data) ? [...self.state.data, ...ress.data.message.data] : self.state.data,
                next_page_url: (ress.data.message && ress.data.message.next_page_url) ? ress.data.message.next_page_url : '',
                hasMore: (ress.data.message && ress.data.message.next_page_url) ? true : false,
                prev_page_url: (ress.data.message && ress.data.message.prev_page_url) ? ress.data.message.prev_page_url : ''
            })
            self.setState({ ProgressBar: false });
        }).catch(function (erro) {
            self.setState({ refreshing: false });
            self.setState({ ProgressBar: false });
        });
    }

    render() {
        return (
            <>
                <div className="locationScreen">
                    <Header data={{ title: strings["navLocation"] }} />

                    <main className="align-container">

                        {this.state.data.map((item, i) =>
                            <div key={"Location_001_" + i} className="location-container">
                                <div className="container-header">
                                    <h2 className="location-title">{item.name}</h2>
                                    <a href={item.google_map_url} target="_blank" rel="noopener noreferrer" className="map-link">
                                        <img className="map-icon" src={images['orange-location']} alt="" />
                                        <span id="mapLink">{strings["mapLink"]}</span>
                                    </a>
                                </div>

                                <img className="location-image" src={(item.image_url) ? item.image_url : images['location-1']} alt="" />
                                <div className="info-wrap">

                                    <h2 id="addressText">{strings["addressText"]}</h2>
                                    <p> {item.address}</p>

                                    <h2 id="openHours">{strings["openHours"]}</h2>
                                    <p id="dateText">{item.open_hours}</p>

                                    <h2 id="contactText">{strings["contactText"]}</h2>
                                    <p>{item.contact}</p>
                                </div>
                            </div>
                        )}

                        <div className='load-more'>
                            {this.state.refreshing && <Spin />}
                            {this.state.hasMore && !this.state.refreshing && (
                                <Button type="submit" id="loginButton" className="load-more-button" loading={this.state.isLoading} onClick={() => this.loadDataNextPage(this.state.next_page_url ? this.state.next_page_url : '')}>
                                    {strings['Load More']}
                                </Button>
                            )}
                            {(!this.state.refreshing && this.state.data && this.state.data.length <= 0) ?
                                <p>{strings["No more data to load"]}</p>
                                : null}
                        </div>

                    </main >

                    {this.state.access_token ?
                        <Footer />
                        :
                        <PublicFooter />
                    }
                </div>
            </>
        );
    }
}

export default LocationScreen;
